import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import List from "./List";
import Item from "./Item";
import { breakpoints } from "styles/grid";

const NavTabs = styled("nav")`
	display: flex;
	align-items: center;
	width: 100%;

	${({ withMarginRight }) =>
		withMarginRight &&
		css`
			margin-right: 1rem;
		`}

	${({ noMargin }) =>
		noMargin === true
			? css``
			: css`
					margin-bottom: 1rem;
			  `}

	${Item} {
		&:hover,
		&:focus {
			background-color: ${({ theme: { colors } }) => colors.itemsHover};
			border-radius: ${({ theme: { borderRadius } }) =>
				borderRadius.element};
		}
		&:active {
			background-color: ${({ theme: { colors } }) => colors.itemsHover};
		}

		${({ noAfterElement }) =>
			noAfterElement === true
				? css``
				: css`
						&.active::after {
							content: "";
							position: absolute;
							left: 0;
							bottom: 0;
							width: 100%;
							background-color: transparent;
							height: 2px;
							background-color: ${({ theme: { colors } }) =>
								colors.primary};
							pointer-events: none;
							z-index: 1;
						}
				  `}

		${({ isInfinityRanksNav }) =>
			isInfinityRanksNav &&
			css`
				margin-right: 0.25rem;
				padding: 0 0.5rem;
			`}

		${({ noItemHover }) =>
			noItemHover &&
			css`
				&:hover,
				&:focus {
					background-color: transparent !important;
				}
			`}
	}

	position: relative;
	${({ line }) =>
		line &&
		css`
			${List} {
				width: 100%;
				position: relative;
				padding: 0 0 0.5rem;
				&:after {
					content: "";
					border-bottom: 2px solid
						${({ theme: { colors } }) => colors.buttonsDefaultGrey};
					position: absolute;
					bottom: calc(7px);
					left: 0;
					width: 100%;
					z-index: 0;
				}
			}

			${Item} {
				margin-right: 0.25rem;

				@media (max-width: ${breakpoints.phone - 1}px) {
					margin-right: 0rem;
				}
			}

			@media (max-width: ${breakpoints.phone - 1}px) {
				${Item} {
					padding: 0rem 0.5rem;
				}
			}
		`}

	@media (max-width: ${breakpoints.phone - 1}px) {
		flex: 1;
		gap: 0.25rem;
	}
`;

// Przykład - Paginacja
const NavPills = styled("nav")`
	display: flex;
	align-items: center;

	${Item} {
		margin-top: 0.1rem;
		& + ${Item} {
			margin-left: 0.25rem;
		}
		&:hover,
		&:focus {
			background-color: ${({ theme: { isDarkMode } }) =>
				isDarkMode
					? "var(--dz-ref-color-gray400)"
					: "var(--dz-ref-color-gray050)"};
		}
		&:active {
			background-color: ${({ theme: { isDarkMode } }) =>
				isDarkMode
					? "var(--dz-ref-color-gray500)"
					: "var(--dz-ref-color-gray300)"};
		}

		// ** Aktualnie zaznaczona opcja - np. wybrana strona paginacji
		&.active {
			background-color: ${({ theme: { isDarkMode } }) =>
				isDarkMode
					? "var(--dz-ref-color-gray400)"
					: "var(--dz-ref-color-gray050)"};
			&:hover,
			&:focus {
				background-color: ${({ theme: { isDarkMode } }) =>
					isDarkMode
						? "var(--dz-ref-color-gray500)"
						: "var(--dz-ref-color-gray300)"};
			}
			&:active {
				background-color: ${({ theme: { isDarkMode } }) =>
					isDarkMode
						? "var(--dz-ref-color-gray600)"
						: "var(--dz-ref-color-gray400)"};
			}
		}
		border-radius: 50%;
	}
`;

const Nav = ({ appearance, noLine, ...props }) => {
	return appearance === "pills" ? (
		<NavPills {...props} />
	) : (
		<NavTabs line={!noLine} {...props} />
	);
};

Nav.defaultProps = {
	noMargin: false,
	noLine: false,
	appearance: "tabs",
};

Nav.propTypes = {
	noMargin: PropTypes.bool,
	noLine: PropTypes.bool,
	appearance: PropTypes.oneOf(["pills", "tabs"]),
};

export default Nav;
